import * as React from "react"
import WithRoot from "./withRoot"
import HomePage from "../components/HomePage"

const IndexPage = () => <HomePage></HomePage>

export default WithRoot(IndexPage)
